import axios from "axios";

// get products by category
export const getProductsBybrand = async (brandId) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/products-handler/?brand_id=${brandId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching products:", error);
    throw error;
  }
};